<template>
    <v-simple-table style="margin:30px 5px">
        <thead>          
            <th class="text-left"
                v-for="(item, index) in updatedFields" 
                :key="index"
                :class="[
                    'size-x-small', 
                    item === 'amount' ? 'text-right' : 'text-left'
                  ]"     
                
              > 
             {{ titles[item] }} </th>
        </thead>
        <tbody>
            <tr v-for="(line, index) in dataRep" :key="index">       
                <td
                  v-for="(field, idx) in updatedFields"
                  :key="idx"   
                  :class="[
                      'size-x-small', 
                      field === 'amount' ? 'text-right' : 'text-left'
                    ]"              
                >
                  {{ field === 'amount' ? $currencyNoDec.format(line[field]) : line[field] }}
                </td>
            </tr>
        </tbody>
        <tfoot v-if="showTotal">
        <tr>
          <td
            v-for="(field, idx) in updatedFields"
            :key="'footer-' + idx"
            :class="[
              'size-x-small',
              field === 'amount' ? 'text-right font-bold' : 'text-left font-bold'
            ]"
          >
            <span v-if="field === 'amount'">
              {{ $currencyNoDec.format(totalAmount) }}
            </span>
            <span v-else-if="idx === 0">Total</span>
          </td>
        </tr>
      </tfoot>
    </v-simple-table>   
</template>

<script>
export default {
  props: {
    dataRep: {
      type: Array,
      default: () => [],
    },
    fields: {
        type: Array,
    },
    showTotal: {
      type: Boolean,
      default: true
    }
  },  
  data: () => ({    
    titles: {
          fecha_gasto: 'Fecha',
          tipo_egreso: 'Egreso',
          payment_type_name: 'Gasto',
          concept: 'Concepto',  
          description: 'Descripción',
          status: 'Status',
          supplier: 'Proveedor',
          referencia: 'Ref',
          amount: 'Cantidad',
                 
    },
    updatedFields:{}
  }),
  created() {
   console.log(this.fields);
   this.updatedFields = this.fields.map(field => 
       field === 'paymentTypeId' ? 'payment_type_name' : field
  );
  },
  computed: {
    totalAmount() {
      return this.dataRep.reduce((sum, line) => {
        return sum + (parseFloat(line.amount) || 0)
      }, 0)
    }
  },
}
</script>
<style lang="scss" scoped>
@import './src/assets/style.scss';
</style>